import { w as f } from "./index760.mjs";
var i = f, o = i("iterator"), a = !1;
try {
  var l = 0, e = {
    next: function() {
      return { done: !!l++ };
    },
    return: function() {
      a = !0;
    }
  };
  e[o] = function() {
    return this;
  }, Array.from(e, function() {
    throw 2;
  });
} catch {
}
var v = function(r, c) {
  try {
    if (!c && !a)
      return !1;
  } catch {
    return !1;
  }
  var n = !1;
  try {
    var t = {};
    t[o] = function() {
      return {
        next: function() {
          return { done: n = !0 };
        }
      };
    }, r(t);
  } catch {
  }
  return n;
};
export {
  v as c
};
